import { ReactNode, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect, Route, useHistory, useLocation } from 'react-router-dom';
import { Layout, Modal } from 'antd';

import HelpCenterHeader from '@/components/HelpCenterLayout/HelpCenterHeader';
import ApplicationFooter from '@/components/PrivateLayout/ApplicationFooter';

import './style.less';
import WhatsAppButton from '@/components/HelpCenterLayout/WhatsAppButton';
import { getUserFromLocalStorage } from '@/utils/user';
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import { authOperations } from '@/state/ducks/auth';
import { useQueryClient } from 'react-query';
import { store } from '@/Root';
import { useDispatch } from 'react-redux';
import { APP_NAME } from '@/index';
const { Content } = Layout;

interface HelpCenterLayoutProps {
  path: string;
  exact?: boolean;
  children: ReactNode;
}

function HelpCenterLayout({ path, exact, children }: HelpCenterLayoutProps) {
  const location = useLocation();
  const history = useHistory();

  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const userData = getUserFromLocalStorage();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [location]);

  useEffect(() => {
    if (userData.accessToken) {
      const tokenData = jwtDecode<{ exp?: number }>(userData.accessToken);

      if (tokenData && tokenData.exp) {
        const timestamp = tokenData.exp * 1000;

        if (
          !moment(timestamp).isValid() ||
          moment(moment(timestamp).subtract(30, 'minutes')).isSameOrBefore(
            moment(),
          )
        ) {
          refreshToken();
        }
      }
    }
  }, [userData]);

  async function refreshToken() {
    try {
      await store.dispatch(authOperations.handleRefreshToken());
    } catch (error) {
      Modal.confirm({
        title: 'Sessão expirada',
        content:
          'Sua sessão foi expirada devido ao tempo sem atividades. Por favor, faça login novamente.',
        cancelButtonProps: { style: { display: 'none' } },
        okText: 'Fechar',
      });
      logout();
    }
  }

  function logout() {
    queryClient.clear();
    dispatch(authOperations.handleLogout());
    history.replace(`/login?redirect=${window.location.pathname}`);
  }

  if (!userData.accessToken || !userData.refreshToken)
    return <Redirect to={`/login?redirect=${window.location.pathname}`} />;

  return (
    <Route
      path={path}
      exact={exact}
      render={() => (
        <Layout
          style={{ minHeight: '100vh' }}
          className="layout-fill help-center"
        >
          <Helmet titleTemplate={`%s | ${APP_NAME}`} defaultTitle={APP_NAME} />

          <HelpCenterHeader />

          <Content className="content-wrapper">
            <div className="content-wrapper-content">{children}</div>
          </Content>

          <ApplicationFooter />

          <WhatsAppButton />
        </Layout>
      )}
    />
  );
}

export default HelpCenterLayout;
